import React, { Suspense, lazy } from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import NavbarMain from './components/NavbarMain'

import ScrollToTop from './components/ScrollToTop'
import Preloader from './components/Preloader'

const HomePage = lazy(() => import('./pages/HomePage'));
const InfoPage = lazy(() => import('./pages/InfoPage'));
const MapPlotPage = lazy(() => import('./pages/MapPlotPage'));




const App = () => {

  return (
    <>

      <NavbarMain />
      <Suspense fallback={<Preloader />}>
        <Routes>

          <Route exact path="/" element={<HomePage />} />;
          <Route exact path="/info" element={<InfoPage />} />;
          <Route exact path="/fbs-wri" element={<MapPlotPage />} />;



        </Routes>
      </Suspense>
      <ScrollToTop />


    </>

  )
}

export default App